export default __webpack_public_path__ + "static/media/my.44aaa7f7.svg";